import { cloneDeep } from 'lodash'
import { updatePageMetaDataExps, updatePageMetaData } from '../utils/exps'
import * as T from './types'

function getPagesMap(pages = []) {
    const tmpPages = pages ? [...pages] : []
    const namesMap = {}
    for (let i = 0; i < tmpPages.length; i++) {
        const page = tmpPages[i]
        if (page.type !== 'folder') {
            namesMap[page.routeName] = cloneDeep(page)
        } else if (Array.isArray(page.children)) {
            tmpPages.push(...page.children)
        }
    }
    return namesMap
}

export default {
    [T.CACHE_COOKIES](state, payload) {
        state.cookies = payload
    },
    [T.SET_APP_DETAIL](state, payload) {
        state.app = payload
    },
    [T.SET_APP_SETTING](state, payload) {
        state.appSetting = payload
    },
    [T.SET_VALID_PURVIEW](state, payload) {
        const { purviewList } = payload || {}
        const purview = (purviewList && JSON.parse(purviewList)) || {}
        state.validPurview = purview
    },
    [T.SET_CLASSIFY_COMPONENTS](state, payload) {
        state.classifyComponents = payload
    },
    [T.SET_COMPONENTS](state, payload) {
        state.components = payload
    },

    [T.SET_PRESETED_COMPONENT](state, payload) {
        state.presetedComponents = payload
    },
    [T.SET_CUSTOMIZE_COMPONENT](state, payload) {
        state.customizeComponents = payload
    },
    [T.SET_BUILTIN_COMPONENT](state, payload) {
        state.builtinComponents = payload
    },
    [T.SET_SPECIAL_COMPONENT](state, payload) {
        state.specialComponents = payload
    },

    [T.SET_FORM_COMPONENT](state, payload) {
        state.formComponents = Object.freeze(payload)
    },

    [T.REGEST_BIZ_COMPONENTS](state, payload) {
        state.bizComponents.push(payload)
    },
    [T.SET_PAGES](state, payload) {
        state.pages = [...cloneDeep(payload)]
    },
    [T.SET_SYSTEM_PAGES](state, payload) {
        state.systemPages = payload
    },
    [T.SET_CONF_LIST](state, payload) {
        const { pages = [] } = state
        const pagesMap = getPagesMap(pages)
        const { hasUserGroupApi = false } = payload
        let { roles = [] } = payload
        const { metadata } = payload
        roles = roles.map(role => {
            role.metadata = cloneDeep(metadata) || {}
            role.metadata.views = role?.tabs?.items?.map?.(item => {
                if (pagesMap[item.href.name]) {
                    return pagesMap[item.href.name].metadata
                }
                return {}
            }) ?? []

            return role
        })

        state.hasConfApi = hasUserGroupApi
        state.confList = { ...payload, roles }
        state.desingConf = payload
        state.confLoading = false
    },
    [T.SET_SYSTEM_CONF_LIST](state, payload) {
        state.systemConfList = payload || []
    },
    [T.SET_USER_LIST](state, payload) {
        state.userList = payload || []
    },
    [T.SET_APP_LIST](state, payload) {
        state.appList = payload
    },
    [T.SET_TEMPLATE_LIST](state, payload) {
        state.templateList = payload
    },
    [T.SET_ICON_INFO](state, payload) {
        const { cssUrl = '', icons = [], suffix = '' } = payload
        state.icons = icons
        state.iconUrl = cssUrl
        state.iconSuffix = suffix
    },
    [T.SET_METADATA_STATUS](state, payload) {
        const { isPublished } = payload
        state.isAllPublish = isPublished
    },
    [T.UPDATE_LOADING](state, payload) {
        state.globalLoading = payload
    },
    [T.UPDATE_REFRESH_FLAG](state, payload) {
        state.refreshFalg = payload
    },
    [T.SET_BUSINESS_ENV_DETAIL](state, payload) {
        state.businessEnv = payload
    },
    [T.SET_PAGE_LOCKER_ID](state, payload) {
        const { key, lock } = payload
        const cloneData = cloneDeep(state.lockedPageId)
        state.lockedPageId = {
            ...cloneData,
            [key]: lock,
        }
    },
    [T.SET_LOCKER_LOADING](state, payload) {
        const { key, status } = payload
        const cloneData = cloneDeep(state.lockerLoading)
        // 只记录正在 loading 的 key
        if (status) {
            state.lockerLoading = {
                ...cloneData,
                [key]: status,
            }
        } else {
            delete cloneData[key]
            state.lockerLoading = cloneData
        }
    },
    [T.SET_FIRST_LOCKER_LOADED](state, payload) {
        state.firstLockerLoaded = payload
    },
    [T.SET_ASSIGNED_PAGE_LOADING](state, payload) {
        state.assignedPageLoading = payload
    },
    // 开发本地自定义组件
    [T.SET_LOCAL_COMPONENT](state, payload) {
        state.localComponents = payload
    },
    // 热更新组件的meta.json数据
    [T.UPDATE_LOCAL_COMPONENT](state, payload) {
        state.localComponents = state.localComponents.map(comp => {
            if (comp.realName === payload.name) {
                return { ...payload, realName: comp.realName }
            }
            return comp
        })
    },

    [T.UPDATE_ROOTING_PAGE_EXPRESSION](state, payload) {
        const { expression, pageId } = payload
        const pages = updatePageMetaDataExps(state.pages, expression, pageId)
        state.pages = pages
    },

    [T.UPDATE_ROOTING_PAGE_TENANT](state, payload) {
        const { isTenant, pageId } = payload
        const pages = updatePageMetaData(state.pages, pageId, pageMeta => { pageMeta.isTenant = isTenant; return pageMeta })
        state.pages = pages
    },
    [T.SET_TABS_MESSAGE_COUNT](state, payload) {
        const { type, count = 0 } = payload
        if (type) {
            state.tabsMessageCount[type] = count
        }
    },
}
